export default "__VITE_ASSET__BXUm5Vm6__"